import { useState, type FormEvent } from "react";

import { Button } from "@/components/ui/Button";
import { ArrowRightIcon, UserIcon } from "@/components/ui/icons";
import { PasswordField } from "@/components/ui/PasswordField";
import { TextField } from "@/components/ui/TextField";
import { toFormErrors } from "@/utils/apiErrors";

import { FormAlert } from "./FormAlert";
import { RememberToggle } from "./RememberToggle";
import { useLogin } from "./useSession";

export function LoginForm() {
  const login = useLogin();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);

  const errors = login.isError ? toFormErrors(login.error) : null;
  const canSubmit = identifier.trim().length > 0 && password.length > 0;

  // Clear stale server errors as soon as the player edits the form.
  const clearErrors = () => {
    if (login.isError) login.reset();
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!canSubmit || login.isPending) return;
    login.mutate({ identifier: identifier.trim(), password, remember });
    // On success the session cache updates and the route guard redirects.
  };

  return (
    <form noValidate onSubmit={handleSubmit} className="mt-7 space-y-5">
      {errors?.message ? <FormAlert message={errors.message} /> : null}

      <TextField
        label="Citizen handle / email"
        name="identifier"
        autoComplete="username"
        autoFocus
        placeholder="Kingsley_97"
        leadingIcon={<UserIcon />}
        value={identifier}
        onChange={(event) => {
          setIdentifier(event.target.value);
          clearErrors();
        }}
        error={errors?.fields.identifier}
      />

      <PasswordField
        label="Password"
        name="password"
        autoComplete="current-password"
        placeholder="••••••••"
        value={password}
        onChange={(event) => {
          setPassword(event.target.value);
          clearErrors();
        }}
        error={errors?.fields.password}
      />

      <RememberToggle checked={remember} onChange={setRemember} />

      <Button
        type="submit"
        className="h-14 w-full text-headline-sm"
        loading={login.isPending}
        disabled={!canSubmit}
        icon={<ArrowRightIcon />}
      >
        {login.isPending ? "Entering…" : "Enter Coal City"}
      </Button>
    </form>
  );
}